import api from '../api'

export default {
    namespaced: true,
    state: {
        marketAccount: {},
        date_log: '',// 记录列表公用时间
        updateLog: {// 修改记录
            beanList: [],
            total: 0
        },
        jpLog: {// 注入彩池记录
            beanList: [],
            total: 0
        },
        sendLog: {// 赠送记录
            beanList: [],
            total: 0
        },
        waitingRecordLog: {// 待手动赠送记录
            beanList: [],
            total: 0,
        },
        horseRaceLampLog: {// 跑马灯注入记录
            beanList: [],
            total: 0
        },
        JPSystemChipLog: {// 彩金服务空抽记录
            beanList: [],
            total: 0
        },
        RedPackLog: {// 红包雨玩家记录
            beanList: [],
            total: 0
        }
    },
    getters: {
        log_start: state => {
            return state.date_log&&state.date_log[0] || ''
        },
        log_end: state => {
            return state.date_log&&state.date_log[1] || ''
        }
    },
    mutations: {
        setStateMarketAccount(state, info) {
            state.marketAccount = info
        },
        setStateDate(state, info) {
            state.date_log = info;
        },
        setStateUpdateLog(state, info) {
            state.updateLog = info
        },
        setStateSendLog(state, info) {
            state.sendLog = info
        },
        setStateJpLog(state, info) {
            state.jpLog = info
        },
        setStateWaitingRecordLog(state, info) {
            state.waitingRecordLog = info
        },
        setStateHorseRaceLampLog(state, info) {
            state.horseRaceLampLog = info
        },
        setJPSystemChipLog(state, info) {
            state.JPSystemChipLog = info
        },
        setRedPackLog(state, info) {
            state.RedPackLog = info
        }
    },
    actions: {
        getMarketAccount({commit}) {
            return api.post(`/market/marketAccount`, '营销账户').then(res => {
                commit('setStateMarketAccount', res.data)
            })
        },
        setMarketAccountOp({dispatch}, params) {
            return api.post(`/market/marketAccountOp`, '营销账户金币修改', params).then(() => {
                dispatch('getMarketAccount')
            })
        },
        getUpdateLogList({getters, commit}, page) {
            return api.post(`/market/marketAccountUpdateLogList`, '营销账户修改记录', {
                start: getters.log_start,
                end: getters.log_end,
                page,
            }).then(res => {
                commit('setStateUpdateLog', res.data)
            })
        },
        getJpLogList({getters, commit}, page) {
            return api.post(`/market/marketAccountJpLogList`, '营销账户流水列表', {
                start: getters.log_start,
                end: getters.log_end,
                page,
            }).then(res => {
                commit('setStateJpLog', res.data)
            })
        },
        getSendLogList({getters, commit}, page) {
            return api.post(`/market/marketAccountSendLogList`, '营销账户赠送记录', {
                start: getters.log_start,
                end: getters.log_end,
                page,
            }).then(res => {
                commit('setStateSendLog', res.data)
            })
        },
        getWaitingRecordLogList({getters, commit}, page) {
            return api.post(`/market/marketAccountWaitingRecordLogList`, '营销账户待手动赠送记录', {
                start: getters.log_start,
                end: getters.log_end,
                page,
            }).then(res => {
                commit('setStateWaitingRecordLog', res.data)
            })
        },
        deleteWaitingRecordLog({dispatch}, idList) {
            return api.post(`/market/dealWaitingRecordLog`, '手动赠送处理', {idList}).then(() => {
                dispatch('getMarketAccount')
            })
        },
        getHorseRaceLampLog({getters, commit}, page) {
            return api.post('/horseracelamp/account/add/list', '跑马灯奖池注入记录查询', {
                start: getters.log_start,
                end: getters.log_end,
                page,
            }).then(res => {
                commit('setStateHorseRaceLampLog', res.data)
            })
        },
        getJPSystemChipLog({getters, commit}, page) {
            return api.post('/market/marketJPSystemChip', '跑马灯奖池注入记录查询', {
                start: getters.log_start,
                end: getters.log_end,
                page,
            }).then(res => {
                commit('setJPSystemChipLog', res.data)
            })
        },
        getRedPackLog({getters, commit}, page) {
            return api.post('/market/getRedPackLog', '跑马灯奖池注入记录查询', {
                start: getters.log_start,
                end: getters.log_end,
                page,
            }).then(res => {
                commit('setRedPackLog', res.data)
            })
        }
    }
}